import React from "react";
import { useBannerDocument, type BannerPayload } from "api/queries/useBanner";

interface PageBannerOwnProps {
  title?: string;
  className?: string;
  fallback?: boolean;
  children?: React.ReactNode;
}

interface PageBannerStateProps {
  banner: BannerPayload | null;
}

type PageBannerProps = PageBannerOwnProps & PageBannerStateProps;

function PageBanner({ banner, fallback, children, className, title }: PageBannerProps) {
  const hasDynamicBanner = !!(banner && banner.filedata);

  if (!hasDynamicBanner && fallback === false && !children) {
    return null;
  }

  if (!hasDynamicBanner && children && fallback === false) {
    return <>{children}</>;
  }

  return (
    <div
      className={
        (hasDynamicBanner ? "Page-dynamicBanner" : "Page-banner") +
        (children ? " Page-dynamicBanner--withContent" : "") +
        (className ? ` ${className}` : "")
      }
    >
      {hasDynamicBanner && banner ? (
        <div className="Page-dynamicBanner-center">
          <img src={`data:${banner.mime};base64, ${banner.filedata}`} alt="" aria-hidden="true" />
        </div>
      ) : null}
      {children || (
        <div className="Page-titleWrapper">
          {title ? (
            <h2 className="Page-title">
              <span className="Page-titleSpan">{title}</span>
            </h2>
          ) : null}
        </div>
      )}
    </div>
  );
}

function withBannerData(
  Component: React.ComponentType<PageBannerProps>
): React.ComponentType<PageBannerOwnProps> {
  return function PageBannerData(props: PageBannerOwnProps) {
    const bannerQuery = useBannerDocument();

    return <Component {...props} banner={bannerQuery.banner} />;
  };
}

export default withBannerData(PageBanner);
